import { useQueryClient } from '@tanstack/react-query';

import { useGrapevinePostEventsApi } from '@/features/api/hooks/grapevine-post-events/useGrapevinePostEventsApi';
import { useApiMutation } from '@/features/api/hooks/useApiMutation';
import { invalidatePostCachesForChangedPost } from '@/features/api/utils/postCaches';

export const useUnlikePost = () => {
  const queryClient = useQueryClient();
  const api = useGrapevinePostEventsApi();

  return useApiMutation({
    mutationFn: (postId: string) =>
      api.onUnlikePostRequest({ clientUnlikePostRequest: { postId } }),
    onSuccess: ({ post }) =>
      invalidatePostCachesForChangedPost(queryClient, post)
  });
};
